import { InputAdornment, TextField } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  fetchCatalogList,
  fetchSearchCatalogList,
} from "../../actions/catalog";
import { useDispatch, useSelector } from "react-redux";

import Breadcrumb from "../../components/Reusable/Breadcrumb";
import CatalogListItems from "./CatalogListItems";
import SearchIcon from "@mui/icons-material/Search";
import { t } from "i18next";

const Catalog = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const queryParams = new URLSearchParams(window.location.search);
  let name = queryParams.get("name");

  if (name) {
    const search = window.location.search;
    const match = search.match(/name=([^&]*)/);

    if (match) {
      const rawValue = match[1];
      if (rawValue.endsWith("+")) {
        if (!name.endsWith("+")) {
          name = name.trim() + " +";
        }
      }
    }
  }

  const { catalogList } = useSelector((state) => state.catalogReducer);

  const [searchQueryGlobal, setSearchQueryGlobal] = useState("");

  useEffect(() => {
    if (searchQueryGlobal.length < 2) {
      dispatch(fetchCatalogList(id));
      return;
    }

    const debounceTimer = setTimeout(() => {
      dispatch(fetchSearchCatalogList(searchQueryGlobal));
    }, 500); // 500ms debounce

    return () => clearTimeout(debounceTimer);
  }, [searchQueryGlobal, id, dispatch]);

  return (
    <div className="catalog-main-container">
      <div className="catalog-main-image-holder">
        <img src="/images/catalog-image.png" className="img-fluid" alt="LG" />
      </div>

      <div className="catalog-main-holder">
        <Breadcrumb title={name || t("catalog.products")} returnPage="/back" />

        <TextField
          label={t("catalog.searchProducts")}
          className="search-input-products-global-page"
          fullWidth
          size="small"
          value={searchQueryGlobal}
          onChange={(e) => setSearchQueryGlobal(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />

        {catalogList?.categories?.length > 0 && (
          <div className="category-list-container">
            <ul>
              {catalogList?.categories?.map((category) => (
                <Link
                  key={category.id}
                  to={`/catalog/${category.id}?name=${category.name}`}
                >
                  <li className="category-list-item">
                    <div className="category-list-item-title">
                      {category.name}
                    </div>
                  </li>
                </Link>
              ))}
            </ul>
          </div>
        )}

        <CatalogListItems data={catalogList?.products || []} />
      </div>
    </div>
  );
};

export default Catalog;
